// User config
const ADULTHOOD_AGE = 18;
const DEMO_SPECIALTY = [
  {
    id: 'aba2d397-3230-408d-a301-c0a2d36f7a67',
    name: 'Allergy',
    created_at: '2019-06-21T14:23:48.788Z',
    updated_at: '2019-06-21T14:23:48.788Z',
    short_name: 'allergy',
    distance: 6,
    type: 'specialty',
  },
  {
    id: '382b5a29-56bf-46d7-bbce-9f986b98243b',
    name: 'Ophthalmology',
    created_at: '2019-06-21T14:23:48.788Z',
    updated_at: '2019-06-21T14:23:48.788Z',
    short_name: 'ophthalmology',
    distance: 11,
    type: 'specialty',
  },
  {
    id: 'a2f084a7-81a3-4c7a-a5b6-d8fa3473eba4',
    name: 'General Surgery',
    created_at: '2019-06-21T14:23:48.788Z',
    updated_at: '2019-06-21T14:23:48.788Z',
    short_name: 'surgery',
    distance: 13,
    type: 'specialty',
  },
  {
    id: '46202a49-60ca-4f32-ada1-fb32ae2ef602',
    name: 'Medical Oncology',
    created_at: '2019-09-09T01:21:16.293Z',
    updated_at: '2019-09-09T01:21:16.293Z',
    short_name: 'medicial-oncology',
    distance: 14,
    type: 'specialty',
  },
  {
    id: 'f6c36d25-47fd-43de-ad8b-44a235ceab66',
    name: 'Physical Therapy',
    created_at: '2019-06-21T14:23:48.788Z',
    updated_at: '2019-06-21T14:23:48.788Z',
    short_name: 'physical-therapy',
    distance: 14,
    type: 'specialty',
  },
  {
    id: '5d6512f1-039a-4cfc-97f5-40a4f5d30122',
    name: 'Internal Medicine',
    created_at: '2019-06-21T14:23:48.788Z',
    updated_at: '2019-06-21T14:23:48.788Z',
    short_name: 'internal-medicine',
    distance: 15,
    type: 'specialty',
  },
  {
    id: '58b55273-0617-4380-bd6d-fe6abbb7d7f9',
    name: 'Surgical Oncology',
    created_at: '2019-09-09T01:21:16.293Z',
    updated_at: '2019-09-09T01:21:16.293Z',
    short_name: 'surgical-oncology',
    distance: 15,
    type: 'specialty',
  },
  {
    id: '307b5744-8c2e-4802-874a-41d6f69045a6',
    name: 'Occupational Therapy',
    created_at: '2019-06-21T14:23:48.788Z',
    updated_at: '2019-06-21T14:23:48.788Z',
    short_name: 'occupational-therapy',
    distance: 18,
    type: 'specialty',
  },
  {
    id: 'ddf36f20-5b54-43e7-b38b-121a0b112938',
    name: 'Interventional Radiology',
    created_at: '2019-12-17T23:33:11.147Z',
    updated_at: '2019-12-17T23:33:11.147Z',
    short_name: 'Interventional Radiology',
    distance: 22,
    type: 'specialty',
  },
  {
    id: '7bf1ae97-b8e5-48f4-a8b7-04282c580664',
    name: 'Interventional Cardiology',
    created_at: '2019-12-17T23:33:52.974Z',
    updated_at: '2019-12-17T23:33:52.974Z',
    short_name: 'Interventional Cardiology',
    distance: 23,
    type: 'specialty',
  },
  {
    id: '01608078-71fb-4ae9-83f2-d274f8235db4',
    name: 'GI Health',
    created_at: '2019-10-02T18:09:15.960Z',
    updated_at: '2019-10-02T18:09:15.960Z',
    catch_all_email: null,
    distance: 7,
    type: 'practice',
  },
  {
    id: '405a9d8e-b271-40a9-af98-72b1266c1684',
    name: 'Emu Health',
    created_at: '2019-11-18T22:01:16.239Z',
    updated_at: '2019-11-18T22:01:16.239Z',
    catch_all_email: null,
    distance: 8,
    type: 'practice',
  },
  {
    id: '09bd1da0-d618-4d90-9ec1-cbdf804bf47d',
    name: 'Gallery 57',
    created_at: '2019-06-27T22:03:11.120Z',
    updated_at: '2019-06-27T22:03:11.120Z',
    catch_all_email: null,
    distance: 8,
    type: 'practice',
  },
  {
    id: 'ecc7d2f5-a192-4775-92cc-cabb8f84d2e3',
    name: 'One Medical',
    created_at: '2019-12-04T14:23:41.630Z',
    updated_at: '2019-12-04T14:23:41.630Z',
    catch_all_email: null,
    distance: 9,
    type: 'practice',
  },
  {
    id: 'cd15fbb6-c63a-4066-b023-0f4ec950b256',
    name: 'JelksMedical',
    created_at: '2020-01-09T19:54:07.518Z',
    updated_at: '2020-01-09T19:54:07.518Z',
    catch_all_email: '',
    distance: 10,
    type: 'practice',
  },
  {
    id: '54e05732-262e-43ed-a0d2-ce55273ee1d0',
    name: 'City Allergy',
    created_at: '2019-07-15T16:20:52.034Z',
    updated_at: '2019-07-15T16:20:52.034Z',
    catch_all_email: null,
    distance: 11,
    type: 'practice',
  },
  {
    id: '939f3e95-8df3-4583-b426-db8ea164abdd',
    name: 'Med Alliance',
    created_at: '2019-10-14T13:59:16.479Z',
    updated_at: '2019-10-14T13:59:16.479Z',
    catch_all_email: null,
    distance: 11,
    type: 'practice',
  },
  {
    id: 'db4005c0-077f-41ac-aeb3-57eda82d4276',
    name: 'Core Surgical',
    created_at: '2019-08-21T19:51:02.997Z',
    updated_at: '2019-08-21T19:51:02.997Z',
    catch_all_email: null,
    distance: 11,
    type: 'practice',
  },
  {
    id: 'f8c51890-5b98-423e-97a4-5d6ab031421e',
    name: 'Peyser Dental',
    created_at: '2019-12-05T22:23:53.508Z',
    updated_at: '2019-12-05T22:23:53.508Z',
    catch_all_email: null,
    distance: 11,
    type: 'practice',
  },
  {
    id: '40bf70af-4312-479a-8245-4d9d4eaaf876',
    name: 'MKR Medical PC',
    created_at: '2019-10-17T18:04:45.293Z',
    updated_at: '2019-10-17T18:04:45.293Z',
    catch_all_email: null,
    distance: 12,
    type: 'practice',
  },
  {
    id: '48c024ec-4264-4c4c-b8bc-f1c8f3f37d48',
    first_name: 'Ali',
    last_name: 'Ameri',
    email: 'testemail@example.com',
    phone: '2129968000',
    created_at: '2020-03-10T16:34:39.106Z',
    updated_at: '2020-03-13T16:10:27.877Z',
    admin: false,
    active: false,
    external_id: null,
    external_tag: null,
    sms_opt_out: false,
    phone_for_sms: '2129968000',
    stripe_customer_id: null,
    user_join_name: 'AliAmeri',
    bio: 'Hematology/Oncology ',
    practice_id: '53e9d704-3167-40b7-9f13-ddb688851ddd',
    user_id: '6e176170-2f53-4799-b56f-001ff1f426a0',
    image_url:
      'http://stagingqwell.wpengine.com/wp-content/uploads/2020/03/Dr.-Ali-Ameri-MD-e1584115528511.jpg',
    title: 'Dr.',
    profile_url: '',
    degree: 'MD',
    education:
      'George Washington University School of Medicine And Health Sciences ',
    homepage_url: '',
    provider_url: null,
    restricted: false,
    preferred_age: 'all',
    preferred_gender: 'all',
    isactive: false,
    history: null,
    type: 'provider',
  },
  {
    id: '6a1f51ba-7be1-42b2-a5ba-17eecead64c4',
    first_name: 'Alan',
    last_name: 'Dayan',
    email: 'adayan@nyretinaconsultants.net',
    phone: '(212)677-2000',
    created_at: '2019-07-10T23:52:37.628Z',
    updated_at: '2020-01-31T15:50:05.144Z',
    admin: false,
    active: false,
    external_id: null,
    external_tag: null,
    sms_opt_out: false,
    phone_for_sms: '(212)677-2000',
    stripe_customer_id: null,
    user_join_name: 'AlanDayan',
    bio: 'Ophthalmologist',
    practice_id: '4118d1db-a2b4-47b9-ba50-44aef9598de1',
    user_id: '39bc164b-6c15-46fd-9aa4-d9718cc7827c',
    image_url:
      'https://qwell.com/wp-content/uploads/2019/07/alan-dayan-image-3-e1562802666100.jpg',
    title: 'Dr.',
    profile_url: '',
    degree: 'MD',
    education: '',
    homepage_url: 'https://www.mountsinai.org/profiles/alan-r-dayan',
    provider_url: null,
    restricted: false,
    preferred_age: 'all',
    preferred_gender: 'all',
    isactive: false,
    history: null,
    type: 'provider',
  },
  {
    id: '0a241ef9-af50-49b9-bed6-af7961ff16e3',
    first_name: 'Alla',
    last_name: 'Belilovsky',
    email: 'belilovskyoffice@yahoo.com',
    phone: '(212)207-3990',
    created_at: '2019-08-19T21:18:58.670Z',
    updated_at: '2019-09-12T16:36:38.014Z',
    admin: false,
    active: false,
    external_id: null,
    external_tag: null,
    sms_opt_out: false,
    phone_for_sms: '(212)207-3990',
    stripe_customer_id: null,
    user_join_name: 'AllaBelilovsky',
    bio: null,
    practice_id: 'ff96e36b-5b39-49f0-971b-3fc620297d48',
    user_id: 'a09fb366-5dff-4a0f-b30f-7e589df488e7',
    image_url:
      'https://qwell.com/wp-content/uploads/2019/08/alla-belilovsky.jpg',
    title: 'Dr. ',
    profile_url: null,
    degree: 'DO',
    education:
      'Yeshiva University; NY College of Osteopathic Medicine, DO; Lenox Hill Hospital, Residency',
    homepage_url:
      'https://www.northwell.edu/find-care/find-a-doctor/internal-medicine/dr-alla-belilovsky-do-11357092',
    provider_url: null,
    restricted: false,
    preferred_age: 'all',
    preferred_gender: 'all',
    isactive: false,
    history: null,
    type: 'provider',
  },
  {
    id: '1653156e-65b2-46e0-9ca7-4529dca8a3f4',
    first_name: 'Alan',
    last_name: 'Fard',
    email: 'afard@midtowncardio.com',
    phone: '2126862220',
    created_at: '2019-06-23T00:33:45.910Z',
    updated_at: '2020-06-30T21:49:33.342Z',
    admin: false,
    active: true,
    external_id: null,
    external_tag: null,
    sms_opt_out: false,
    phone_for_sms: '9178410593',
    stripe_customer_id: null,
    user_join_name: 'AlanFard',
    bio: 'Cardiologist, Midtown Cardiovascular',
    practice_id: '9e52f519-368a-4ef4-95d9-d95c27c685a0',
    user_id: '30d592cb-b678-4e2c-914b-fdfbc572804b',
    image_url:
      'https://lh3.googleusercontent.com/2kgtfAfUX5zUMhnIWswzZwIhFMjsR2a-Ty5t3BZwXaxVa-Un8V68X1mgBl6LuW81AQvvDQ=s170',
    title: 'Dr.',
    profile_url: 'https://qwell.com/cardiology/alan-fard-md/',
    degree: 'MD',
    education:
      'Harvard College, Cornell University, MD, Manhattan Eye Ear and Throat Hospital, Residency',
    homepage_url: 'http://www.midtowncardio.com/about.html',
    provider_url: '/cardiology/alan-fard-md',
    restricted: false,
    preferred_age: 'all',
    preferred_gender: 'all',
    isactive: false,
    history: null,
    type: 'provider',
  },
  {
    id: '6d6eda77-2d7b-4b47-9fa3-30618b049ade',
    first_name: 'Alex',
    last_name: 'Katz',
    email: 'alex.katz@nyulangone.org',
    phone: '(718)615-4444',
    created_at: '2019-09-13T02:14:14.484Z',
    updated_at: '2020-01-31T17:06:21.726Z',
    admin: false,
    active: false,
    external_id: null,
    external_tag: null,
    sms_opt_out: false,
    phone_for_sms: '(718)615-4444',
    stripe_customer_id: null,
    user_join_name: 'AlexKatz',
    bio: 'Podiatrist',
    practice_id: 'dac1e0d7-09dc-4336-9509-a82ad6d84c29',
    user_id: 'e13b343c-5be1-44fd-833c-5f3416f754f5',
    image_url:
      'https://qwell.com/wp-content/uploads/2019/09/Dr.-Alex-Katz-DPM.jpg',
    title: 'Dr.',
    profile_url: '',
    degree: 'DPM',
    education: '',
    homepage_url: 'https://nyulangone.org/doctors/1164485827/alex-katz',
    provider_url: null,
    restricted: false,
    preferred_age: 'all',
    preferred_gender: 'all',
    isactive: false,
    history: null,
    type: 'provider',
  },
  {
    id: 'e956a025-f8eb-473f-8736-202e1939ccdf',
    first_name: 'Alan',
    last_name: 'Sheyman',
    email: 'alan.sheyman@mountsinai.org',
    phone: '(212)772-0600',
    created_at: '2019-10-05T21:11:36.599Z',
    updated_at: '2019-10-16T16:48:25.363Z',
    admin: false,
    active: false,
    external_id: null,
    external_tag: null,
    sms_opt_out: false,
    phone_for_sms: '(212)772-0600',
    stripe_customer_id: null,
    user_join_name: 'AlanSheyman',
    bio: null,
    practice_id: '500f0a5b-7834-43c8-ba4c-4a6a09e4770f',
    user_id: 'e07d1813-9699-43e9-b0f9-cc5c1678c492',
    image_url:
      'https://qwellprod.wpengine.com/wp-content/uploads/2019/10/Alan-Sheyman-e1570469231890.png',
    title: 'Dr.',
    profile_url: null,
    degree: 'MD',
    education:
      'University of Michigan; Albert Einstein College of Medicine, MD; Mt Sinai Hospital, Residency',
    homepage_url: 'https://www.retinany.com',
    provider_url: null,
    restricted: false,
    preferred_age: 'all',
    preferred_gender: 'all',
    isactive: false,
    history: null,
    type: 'provider',
  },
  {
    id: '9cd70bb9-e924-4391-ada1-19f568bb52f0',
    first_name: 'Alan',
    last_name: 'Benvenisty',
    email: 'alan.benvenisty@mountsinai.org',
    phone: '2125234706',
    created_at: '2020-03-03T20:35:28.910Z',
    updated_at: '2020-03-13T16:33:45.648Z',
    admin: false,
    active: false,
    external_id: null,
    external_tag: null,
    sms_opt_out: false,
    phone_for_sms: '2125234706',
    stripe_customer_id: null,
    user_join_name: 'AlanBenvenisty',
    bio: 'Vascular Surgeon',
    practice_id: '79b6b4d1-38eb-4739-a301-c0c1b859f457',
    user_id: '3b788b92-ac2e-47c5-8b10-688ec5a59046',
    image_url:
      'http://stagingqwell.wpengine.com/wp-content/uploads/2020/03/Dr.-Alan-Benvenistry-MD-e1584117212359.jpg',
    title: 'Dr.',
    profile_url: '',
    degree: 'MD',
    education: '',
    homepage_url: '',
    provider_url: null,
    restricted: false,
    preferred_age: 'all',
    preferred_gender: 'all',
    isactive: false,
    history: null,
    type: 'provider',
  },
  {
    id: '524af14d-0bbf-46d4-8ab2-4b1488d13a4a',
    first_name: 'Alan',
    last_name: 'Kling',
    email: 'klingderm@gmail.com',
    phone: '(212)288-1300',
    created_at: '2020-01-23T18:55:26.691Z',
    updated_at: '2020-01-23T19:01:04.403Z',
    admin: false,
    active: false,
    external_id: null,
    external_tag: null,
    sms_opt_out: false,
    phone_for_sms: '(212)288-1300',
    stripe_customer_id: null,
    user_join_name: 'AlanKling',
    bio: 'Dermatology, Cosmetics',
    practice_id: '20e50ae4-be94-421e-8d30-0288fbc52bb1',
    user_id: 'ac5abac4-2142-4d3b-a0da-4e74b4d2fa83',
    image_url:
      'https://qwellprod.wpengine.com/wp-content/uploads/2020/01/alankling-e1579805914902.jpg',
    title: 'Dr. ',
    profile_url: '',
    degree: 'MD',
    education: 'New York University Medical School ',
    homepage_url: 'https://klingdermatology.com/',
    provider_url: null,
    restricted: false,
    preferred_age: 'all',
    preferred_gender: 'all',
    isactive: false,
    history: null,
    type: 'provider',
  },
];
module.exports = {
  ADULTHOOD_AGE,
  DEMO_SPECIALTY,
};
